import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar.tsx';
import Hero from './components/Hero.tsx';
import About from './components/About.tsx';
import Service from './components/Service.tsx';
import Programs from './components/Programs.tsx';
import Blog from './components/Blog.tsx';
import Footer from './components/Footer.tsx';
import Spinner from './components/Spinner.tsx';
import useWow from './hooks/useWow.ts';
import BlogPage from './components/BlogPage.tsx';

// Import styles
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'animate.css';
import './assets/css/style.css';

function App() {
  const [loading, setLoading] = useState(true);
  useWow();

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="App">
        {loading && <Spinner />}
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
              <Service />
              <Programs />
              <Blog />
            </>
          } />
          <Route path="/blog/:id" element={<BlogPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 